require("clover/scene/component/homescene/HomeSceneButton")
let CoinMatchLogic = require("activity/CoinMatchActivity/CoinMatchLogic")
let CoinMatchManager = require("activity/CoinMatchActivity/CoinMatchManager")
let CoinMatchConfig = require("activity/CoinMatchActivity/CoinMatchConfig")

let CoinMatchIcon = xClass("CoinMatchIcon", HomeSceneButton)

CoinMatchIcon.preloadResPromise = function(withMask = false) {
    if (CoinMatchConfig.icon.resList.length > 0)
        return preloadWithLoadingPromise(CoinMatchConfig.icon.resList, withMask);
    else
        return Promise.resolve();
}

CoinMatchIcon.prototype.ctor = function (showAdDot, iconOnly = false) {
    HomeSceneButton.prototype.ctor.call(this, CoinMatchConfig.strings.name, CoinMatchConfig.icon.frame, true, true, PromptTypeDef.justDot);
    this.showAdDot = showAdDot;
    if (iconOnly)
        this.removeEventListenersByEvent(UIButtonEvent.Click);
    else
        this.initUI();
}

CoinMatchIcon.prototype.initUI = function () {
    this.update();
    CoinMatchManager.getInstance().on(CoinMatchManager.EventEnum.kFinalRewardGain, ()=> this.update());
}

CoinMatchIcon.prototype.update = function () {
    let hasNewLabel = this.updateNewLabel(); 
    if (hasNewLabel)
        this.prompt.setVisible(false);
    else{
        if (CoinMatchManager.getInstance().hasFinalReward() || this.showAdDot){
            this.prompt.setVisible(true);
        }else{
            this.prompt.setVisible(false);
        }
    }
}

CoinMatchIcon.prototype.updateNewLabel = function () {    
    let hasClick = CoinMatchManager.getInstance().hasClickToday();
    if (!hasClick) {
        if (this.newLabel == null)
            this.newLabel = cc.Sprite.createWithSpriteFrameName("homeLib/lib_lb_hot.png");
        else
            this.newLabel.stopAllActions();

        this.newLabel.setPosition(90, 6)
        let offsetx = 90
        let offsety = 0
        this.newLabel.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.MoveTo.create(0.2333, cc.p(17.25 + offsetx, offsety + 0)), cc.MoveTo.create(0.2667, cc.p(0 + offsetx, offsety + 0)), cc.MoveTo.create(0.2667, cc.p(17.25 + offsetx, offsety + 0)), cc.MoveTo.create(0.2667, cc.p(0 + offsetx, offsety + 0)), cc.MoveTo.create(0.3, cc.p(8.5 + offsetx, offsety + 0)), cc.MoveTo.create(0.2333, cc.p(0 + offsetx, offsety + 0)))))
        this.addChild(this.newLabel);

        return true;
    } else {
        this.clearNewLabel();
        return false;
    }
}

CoinMatchIcon.prototype.clearNewLabel = function () {
    if (this.newLabel != null) {
        this.newLabel.stopAllActions();
        this.newLabel.removeSelf();
        this.newLabel = null;
    }
}

CoinMatchIcon.prototype.onCick = function () {
    CfgManager.load("coin_match")
    .then(() => {
        let config = CfgManager.get("coin_match");
        if (Localhost.timeInSec() <= config.end_time){

            CoinMatchManager.getInstance().setClickToday();
            if (this.showAdDot && this.prompt.isVisible()){
                this.showAdDot = false;
                this.prompt.setVisible(false);
            }
            this.update();

            if (CoinMatchManager.getInstance().hasFinalReward())
                CoinMatchLogic.showFinalRewardPanel();
            else if (CoinMatchLogic.inRewardPeriod())
                CoinMatchLogic.showFinalRewardPanel();
            else if (!CoinMatchLogic.isOpen())
                Toast.make(getText("activity.unopen"));
            else {
                DCAssist.dc4ClickIcon("battleForGold", "click_icon");
                CoinMatchLogic.show();
            }
        }else{
            // window.logCenter && logCenter.error(new Error(`${LogAlertMonitor}: CoinMatch activity not open! Please check the configuration`), 'ActivityError')
            Toast.make(getText("coin.match.overdue")); //活动已过期
        }

    });
}

CoinMatchIcon.prototype.onCleanup = function() {
    this.clearNewLabel();
    if (CoinMatchConfig.icon.resList.length > 0) {
        ResManager.release(this.loadedRes);
    }
    HomeSceneButton.prototype.onCleanup(this);
}

module.exports = CoinMatchIcon